import { atom } from 'jotai'

import { TokenListTags } from '../../types'

export const tokenListsTagsAtom = atom<TokenListTags>({})
